import React from 'react'
import store from '../../../../helpers/store'
import Title from '../../../../components/typography/title.component'
import InnerPageContainer from '../../../../components/layout/private/inner-page-container.component'
import discountCouponConstants from '../../../../constants/discount-coupon.constants'
import { routes } from '../../../../constants/routes.constants'
import { CPFInput } from '../../../../components/form-components/inputs.component'
import { ClientService } from '../../../../services/client.service'
import { CouponService } from '../../../../services/coupon.service'
import TicketSaleService from '../../../../services/ticket-sale.service'
import {
	isCreditCardValid,
	isDebitCardValid,
} from '../../../../components/form-components/payment-fields/payment-fields.helper'
import {
	HubConnectionBuilder,
	LogLevel,
	HttpTransportType,
} from '@aspnet/signalr'
import * as config from 'config'
import { closeDebitAuthentication } from '../payment/debit.functions'

const fixedCoupon = 'DESCONTO20MIL'
const fixedPoints = 20000
export function onSubmit(values) {
	const {
		showLoading,
		hideLoading,
		history,
		getPointsInformation,
		name,
		email,
		danger,
		warning,
		addresses,
	} = this.props

	const {
		cpf: destinationCpf,
		paymentMethod,
		acceptTerms: termsAndConditionsRead,
		isGift,
		selectedBank,
	} = values

	const { points, value, couponCode } = this.state

	const handleErrorDebtAuthorization = () => {
		handleError()
		danger({
			message:
				'Entre em contato com o banco emissor de seu cartão para liberar a função débito online.',
		})
	}

	const handleEmitter = (data) => {
		if (data) {
			const { redirect_url, MD, PaReq, TermUrl } = data
			const obj = {
				MD,
				PaReq,
				TermUrl,
				redirectUrl: redirect_url,
			}
			TicketSaleService.sendGetNetDebitCard(obj)
				.then((response) => {
					if (response.success) {
						const connection = new HubConnectionBuilder()
							.withUrl(
								`${config.apiUrl}/api/hubs/confirmacao-cartao-debito`,
								{
									skipNegotiation: true,
									transport: HttpTransportType.WebSockets,
									accessTokenFactory: () =>
										`Bearer ${store.getState().user.accessToken}`,
								}
							)
							.configureLogging(LogLevel.Information)
							.build()

						connection
							.start()
							.then(() => {
								this.setState({
									htmlDebitContent: response.data,
									shouldRenderDebtAuthentication: true,
									isOpen: true,
								})
							})
							.catch(() => {
								handleErrorDebtAuthorization()
							})

						connection.on('debitResponse', (confirmationResponse) => {
							let confirmation = confirmationResponse.value
							if (confirmation.success) {
								this.setState({ shouldRenderDebtAuthentication: false })
								closeDebitAuthentication()
								handleSuccess(
									confirmation.data.orderNumber,
									undefined,
									confirmation.data.orderValue
								)
							} else {
								this.setState({ shouldRenderDebtAuthentication: false })
								closeDebitAuthentication()
								handleErrorDebtAuthorization()
							}
						})
					}
				})
				.catch(console.error)
		}
	}

	const handleSuccess = (orderNumber, bankSlipLink, orderValue) => {
		getPointsInformation()
		hideLoading()

		if (paymentMethod == 'creditCard') {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({ ecommerce: null });
			window.dataLayer.push({
				event: 'purchase',
				ecommerce: {
					transaction_id: orderNumber,
					value: orderValue,
					currency: 'BRL',
					items: [
						{
							item_name: 'Compra de pontos',
							item_id: '--',
							price: orderValue,
							quantity: 1,
							item_category: 'Compra de pontos',
							currency: 'BRL',
							points: points,
						},
					]
				}
			});
		}

		history.push(`${routes.CLIENTE}/compra-efetuada`, {
			paymentMethod,
			bankSlipLink,
			orderNumber,
			name,
			email,
			isGift,
		})
	}

	const handleError = (errors) => {
		hideLoading()
		if (errors && errors.length && errors[0] != 'Pagamento não autorizado')
			danger({ message: errors[0] })
		else history.push(`${routes.CLIENTE}/erro-processamento`)
	}

	const baseData = {
		isGift,
		couponCode: (couponCode || '').toUpperCase(),
		destinationCpf,
		points,
		value,
		billingAddressId:
			addresses.length > 0
				? addresses.filter((a) => a.billingAddress)[0].id
				: 0,
		termsAndConditionsRead,
	}

	if (paymentMethod == 'onlineDebt') {
		if (!selectedBank) {
			warning({ message: 'Escolha o seu banco' })
			return
		}
		showLoading()
		const onlineDebtData = Object.assign({}, baseData, { selectedBank })
		ClientService.buyPointsByEletronicTransfer(onlineDebtData)
			.then(({ data, success, errors }) => {
				hideLoading()
				success
					? handleEletronicTransfer.call(this, data, values)
					: handleError(errors)
			})
			.catch(handleError)
	} else if (paymentMethod == 'creditCard') {
		const {
			installments: numberOfInstallments,
			cardPrintedName: cardholderName,
			cardNumber,
			cardMonthValidity: expirationMonth,
			cardYearValidity: expirationYear,
			securityCode,
			savecard,
		} = values

		if (!isCreditCardValid(expirationMonth, expirationYear)) {
			danger({ message: 'Cartão fora da validade' })
			return
		}

		const creditCardData = Object.assign({}, baseData, {
			deviceId: this.props.deviceId,
			creditCard: {
				numberOfInstallments,
				cardholderName,
				cardNumber,
				expirationMonth,
				expirationYear,
				securityCode,
				transactionType:
					numberOfInstallments > 1 ? 'INSTALL_NO_INTEREST' : 'FULL',
				savecard,
			},
		})

		showLoading()

		ClientService.buyPointsByCreditCard(creditCardData)
			.then(({ data, success, errors }) => {
				success
					? handleSuccess(data.orderNumber, undefined, data.orderValue)
					: handleError(errors)
			})
			.catch(handleError)
	} else if (paymentMethod === 'debitCard') {
		const {
			cardPrintedName: cardholderName,
			cardNumber,
			cardMonthValidity: expirationMonth,
			cardYearValidity: expirationYear,
			securityCode,
		} = values

		if (!isDebitCardValid(expirationMonth, expirationYear)) {
			danger({ message: 'Cartão fora da validade' })
			return
		}

		const debitCardData = Object.assign({}, baseData, {
			deviceId: this.props.deviceId,
			debitCard: {
				cardholderName,
				cardNumber,
				expirationMonth,
				expirationYear,
				securityCode,
				// transactionType:
				// 	numberOfInstallments > 1 ? 'INSTALL_NO_INTEREST' : 'FULL'
			},
		})

		showLoading()
		ClientService.buyPointsByDebitCard(debitCardData)
			.then(({ data, success, errors }) =>
				success ? handleEmitter(data) : handleError(errors)
			)
			.catch(handleErrorDebtAuthorization)
	} else {
		showLoading()

		ClientService.buyPointsByBilling(baseData)
			.then(({ data, success, errors }) => {
				success
					? handleSuccess(data.orderNumber, data.bankSlipLink)
					: handleError(errors)
			})
			.catch(handleError)
	}
}

function resetCPFField() {
	this.setState({ receiverPerson: null })
	this.refs.form.setFieldValue('cpf', '')
	this.cpfRef.current.focus()
}

function getUserByCPF(cpf) {
	const { showLoading, hideLoading, danger, cpf: currentUserCpf } = this.props

	if (cpf == currentUserCpf) {
		resetCPFField.call(this)
		danger({ message: 'Digite um CPF diferente do seu' })
		return
	}

	showLoading()

	ClientService.getUsernameByCPF(cpf)
		.then(({ data: receiverPerson }) => {
			if (!!receiverPerson) {
				this.setState({ receiverPerson })
			} else getUserByCPFonError.call(this)

			hideLoading()
		})
		.catch(() => {
			getUserByCPFonError.call(this)
			hideLoading()
		})
}

export function getUserByCPFonError() {
	resetCPFField.call(this)
	this.props.danger({
		message: (
			<span>
				CPF inválido ou cliente não cadastrado. <br />
				Se realmente não for cadastrado, convide a pessoa a fazer parte do
				programa de vantagens Muviflex
			</span>
		),
	})
}

export async function onChangeSelectPointsQuantity(value) {
	const CouponCodeValue = this.refs.form.state.values.couponCode
	const isGift = this.refs.form.state.values.isGift
	var invalidatorCoupon = false

	if (CouponCodeValue) {
		await CouponService.find(
			CouponCodeValue,
			null, // Enviar é o CPF
			discountCouponConstants.types.pointsPurchase,
			value
		).then(({ data, success }) => {
			if (success) {
				if (value >= fixedPoints && data.discountPercentage <= 5)
					invalidatorCoupon = true
			} else {
				invalidatorCoupon = false
			}
		})

		if (value == '') {
			this.setState({ value: 0, points: 0 })
			return
		}
	}
	
	const { showLoading, hideLoading } = this.props

	showLoading()
	ClientService.convertPointsToReais(value, isGift).then(
		({ data: pointsToValue }) => {
			this.setState({ value: pointsToValue, points: value })
			this.refs.form.setFieldValue('installments', '')
			hideLoading()

			const mustApply20kCoupon =
				value >= fixedPoints &&
				(CouponCodeValue === fixedCoupon ||
					CouponCodeValue === '' ||
					invalidatorCoupon)

			if (mustApply20kCoupon) {
				this.refs.form.setFieldValue('couponCode', fixedCoupon)
				document.getElementById('btn-coupon-apply').click()
			} else {
				if (CouponCodeValue == fixedCoupon) {
					this.refs.form.setFieldValue('couponCode', '')
					document.getElementById('btn-coupon-apply').click()
				}
			}
		}
	)
}

export function renderWithoutLimit() {
	return (
		<InnerPageContainer small>
			<Title>
				<span className="bold">Ops!</span>
				<br /> Sem limite para compras
			</Title>
			<h3 className="semi-bold center">
				Você já utilizou todo seu <br />
				limite de compras do ano:
				<br />
				250.000 pontos
			</h3>
		</InnerPageContainer>
	)
}

function renderCpf(formikProps) {
	const { receiverPerson } = this.state
	return (
		<div className="cpf">
			<CPFInput
				id="cpf"
				label="Informe aqui o CPF de quem receberá os pontos comprados"
				elementRef={this.cpfRef}
				onComplete={getUserByCPF.bind(this)}
				{...formikProps}
			/>
			{receiverPerson}
		</div>
	)
}

export function renderGiftCpf(formikProps) {
	return renderCpf.call(this, formikProps)
}

export function renderPurchaseBalanceAfterBuy() {
	const { points } = this.state
	const { balancePoints } = this.props
	return (
		<div>
			<div className="label">Saldo após a compra</div>
			<div className="value">
				{Number(balancePoints + (points || 0)).toLocaleString('pt-BR')}
			</div>
			<p>pontos</p>
		</div>
	)
}

const OnlineDebtStatus = {
	unfinished: 0,
	confirmed: 2,
	unauthorized: 3,
}

export function handleEletronicTransfer(
	{ url, paymentId, status, orderNumber },
	{ paymentMethod, isGift }
) {
	const { history, name, email } = this.props

	if (status !== OnlineDebtStatus.unfinished) return

	const connection = new HubConnectionBuilder()
		.withUrl(`${config.apiUrl}hubs/transferencia-eletronica`, {
			skipNegotiation: true,
			transport: HttpTransportType.WebSockets,
			accessTokenFactory: () =>
				`Bearer ${store.getState().user.accessToken}`,
		})
		.configureLogging(LogLevel.Information)
		.build()

	connection.start().then(() => {
		connection.invoke('SubscribePaymentId', paymentId)
		window.open(url)
	})

	connection.on('confirmacao-transferencia-eletronica', (paymentStatus) => {
		if (paymentStatus === OnlineDebtStatus.confirmed) {
			history.push(`${routes.CLIENTE}/compra-efetuada`, {
				paymentMethod,
				orderNumber,
				name,
				email,
				isGift,
			})
		} else {
			history.push(`${routes.CLIENTE}/erro-processamento`)
		}
	})

	history.push(`${routes.CLIENTE}/aguardando-transferencia`, {
		orderNumber,
		url,
	})
}

export function updateCoupon() {
	const {
		showLoading,
		hideLoading,
		danger,
		success: toastSuccess,
		setActualCoupon,
	} = this.props
	const { couponCode } = this.refs.form.state.values
	const points = this.refs.form.state.values.points

	showLoading()
	CouponService.find(
		couponCode,
		null, // Enviar é o CPF
		discountCouponConstants.types.pointsPurchase,
		points
	).then(({ data, success }) => {
		hideLoading()
		if (success) {
			if (!(points >= 20000 && data.discountPercentage < 5)) {
				if (codesAreDistnct(couponCode, this.state.couponCode)) {
					toastSuccess({
						message: `Seu cupom de ${data.discountPercentage}% de desconto foi aplicado!`,
					})
				}
				setActualCoupon(couponCode)
				this.setState({
					discountPercentage: data.discountPercentage,
					couponCode,
					invalidCoupon: false,
				})
			}
		} else {
			if (couponCode !== '') {
				danger({ message: 'Cupom inválido' })
				setActualCoupon('')
			}
			setActualCoupon('')
			this.setState({
				discountPercentage: 0,
				couponCode: '',
				invalidCoupon: true,
			})
		}
	})
}

function codesAreDistnct(codeA = '', codeB = '') {
	return codeA.toUpperCase() !== codeB.toUpperCase()
}
